/**
    * @description      : 
    * @author           : 
    * @group            : 
    * @created          : 14/03/2026 - 15:55:46
    * 
    * MODIFICATION LOG
    * - Version         : 1.0.0
    * - Date            : 14/03/2026
    * - Author          : 
    * - Modification    : 
**/

import axios from "axios";

export const batchApis = {
  /**
   * Batch elevation lookup - fetches elevations for multiple coordinates in a single API call
   * @param points - Array of coordinates {lat, lng}
   * @returns Response with elevations array in same order as inputs
   */
  getBatchElevation: async (points: Array<{ lat: number; lng: number }>) => {
    try {
      const response = await axios.post(
        `https://backend.pv-glarecheck.com/elevation/batch`,
        { points },
        { headers: { 'Content-Type': 'application/json' } }
      );
      return response;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Batch azimuth calculation - calculates azimuths for multiple PV areas in a single API call
   * @param pvAreas - Array of PV area data with 4 points each
   * @returns Response with azimuth results array
   */
  getBatchAzimuth: async (pvAreas: Array<any>) => {
    try {
      const response = await axios.post(
        `https://backend.pv-glarecheck.com/azimuth/batch`,
        { pv_areas: pvAreas },
        { headers: { 'Content-Type': 'application/json' } }
      );
      return response;
    } catch (error) {
      throw error;
    }
  },
};
